import React, { useState } from 'react';
import {
  ModalVideoContainer,
  ModalVideoPlayButton
} from 'elements/video/modal.video.styles'
import OverlayVideo from './overlay.video';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

interface ModalVideoProps {
  thumbnail: IGatsbyImageData;
  videoUrl: string;
}

const ModalVideo = ({ thumbnail, videoUrl }: ModalVideoProps): JSX.Element => {
  const [ overlayVisible, setOverlayVisible ] = useState(false)

  return (
    <>
      <ModalVideoContainer>
        <GatsbyImage image={thumbnail} alt="Video poster image" />
        <ModalVideoPlayButton onClick={() => setOverlayVisible(!overlayVisible)} />
      </ModalVideoContainer>
      <OverlayVideo
        overlayVisible={overlayVisible}
        setOverlayVisible={setOverlayVisible}
        src={videoUrl}
      />
    </>
  );
};

export default ModalVideo;
